<template class="custom-template">
  <TecBanHeader/>
  <q-layout>
    <q-page-container>
      <q-page class="q-pa-md">
        <q-card class="q-ma-md" bordered color="red">
          <q-card-section class="text-h6 text-white bg-red">
            Acesso negado!
          </q-card-section>
          <q-card-section class="text-center">
            Usuário sem grupos ou perfil de acesso necessário!
          </q-card-section>
        </q-card>
      </q-page>
    </q-page-container>

  </q-layout>


</template>

<script>


import TecBanHeader from '../TecBanHeader.vue'




export default {
  components: {
    TecBanHeader,
  },
  name: 'AcessoNegado',
  methods: {

  },
  computed: {
  }
};
</script>

<style scoped>

</style>